

window.myjQuery(document).ready(function($) {

  $('body').on('click', '.btn-turbo', function() {

    if ($(this).attr('href')) {
      $(this).data('link', $(this).attr('href'));
    }

    querystring = 'cart_hash=' + $("meta[name='CART_HASH']").attr("content");

    link = $(this).data('link');
    link += (link.match(/\?/) ? '&' : '?') + querystring;

    $(this).data('link', link);

    if (typeof $(this).data('modal-window') === "undefined") {
      $(this).attr('data-no-modal', 'true');
    }

    if (typeof $(this).data('loader') === "undefined") {
      $(this).attr('data-no-loader', 'true');
    }

    turbo($(this), false);

    // Return false when interacting with anchor tags.
    if ($(this).attr('href')) {
      return false;
    }
  });

  function turbo(e) {

    // Get modal window selector from data attribute, default to #modalWindow
    var modalWindow = e.data('modal-window') ? '#' + e.data('modal-window') : '#modalWindow';

    // Reset modal size.
    if (! e.data('no-modal')) {
      $('div.modal-dialog').removeClass('modal-lg', 400);
      $('div.modal-dialog').removeClass('modal-sm', 400);
    }

    // Display the modal.
    if (! e.data('no-modal')) {
      $(modalWindow).modal('show');
    }

    var form = null;

    if (! e.data('no-modal')) {
      if (e.data('form')) {
        form = $(modalWindow + ' form'+ e.data('form'));
      } else {
        form = $(modalWindow + ' form');
      }
    } else {
        form = $('form#'+ e.data('form'));
    }

    var formData = false;

    // var formAction = e.data('type') == 'POST' ? 'POST' : 'GET';
    var upload = e.data('upload') ? true : false;
    // var formType = upload ? 'POST' : formAction;
    var loader = e.data('no-loader') ? false : true;
    // Show a target class.
    var show = e.data('show') ? e.data('show') : false;
    var hide = e.data('hide') ? e.data('hide') : false;

    if (upload) {
      formData = new FormData(form[0]);
    } else {
      // Build parameters to send with the request.
      params = {};
      // params.user_id = user_id;
      // params._token = csrfToken;
      if (e.data('type') == 'POST') {
        formData = $.param(params) + '&' + form.serialize();
      } else {
        formData = form.serialize();
      }
    }

    // Simple alert popup confirmation.
    if (e.data('confirmation')) {
      if (! confirm(e.data('confirmation'))) {
        return;
      }
    }

      $.ajax({
          type: e.data('type') == 'POST' ? 'POST' : 'GET',
          url: e.data('link'),
          cache: false,
          data: formData,
          contentType: upload ? false : 'application/x-www-form-urlencoded', // formData // The type of data expected to send to the server.
          processData: upload ? false : true, // formData
          dataType: 'json', // The type of data expected to receive back from the server.
          context: document.body,
          global: false,
          async: true,
          beforeSend: function() {
            if (loader) {
              $(modalWindow + ' .modal-dialog-live').hide();
              $(modalWindow + ' .modal-dialog-loader').show();
              $(".btn-turbo").attr("disabled", true);
            }

            if (show) {
              $(show).removeClass('d-none');
              $(show).show();
            }

            if (hide) {
              $(hide).hide();
            }
          }}).done(function (data) {

            if(data.alert) {
              alert(data.alert_msg);
            }

            if(data.uri) {
              history.replaceState(null, '', '/'+ data.uri);
            }

            if(data.title) {
              document.title = data.title;
            }

            if (data.download) {
                window.location.href = data.download_url;
            }

            if (data.redirect) {
                window.location.href = data.redirect_url;
            }

            if(data.dom_inject) {
              $.each(data.inject.elements, function(k, v) {
                if(v.method == 'remove') {
                  $(v.target).remove();
                }
                if(v.method == 'empty') {
                  $(v.target).empty();
                }
                if(v.method == 'before') {
                  $(v.target).before(v.body);
                }
                if(v.method == 'after') {
                  $(v.target).after(v.body);
                }
                if(v.method == 'prepend') {
                  $(v.target).prepend(v.body);
                }
                if(v.method == 'append') {
                  $(v.target).append(v.body);
                }
                if(v.method == 'replace') {
                  $(v.target).replaceWith(v.body);
                }
                if(v.method == 'fill') {
                  $(v.target).html(v.body);
                }
                if(v.method == 'value') {
                  $(v.target).val(v.value);
                }
                if(v.method == 'addClass') {
                  $(v.target).addClass(v.value);
                }
                if(v.method == 'removeClass') {
                  $(v.target).removeClass(v.value);
                }
                if(v.method == 'hide') {
                  $(v.target).hide();
                }
                if(v.method == 'show') {
                  $(v.target).show();
                }
                if(v.method == 'click') {
                  $(v.target).click();
                }
                if(v.method == 'link') {
                  $(v.target).attr('href', v.value);
                }
                if(v.method == 'img') {
                  $(v.target).attr('src', v.value);
                }
                if(v.method == 'text') {
                  $(v.target).text(v.value);
                }
                if(v.method == 'trigger') {
                  $(v.target).trigger(v.value);
                }
                if(v.method == 'scrollintoview') {
                  document.getElementById(v.target).scrollIntoView();
                }
              });
            }

            if(data.presentation_date_calendar) {
              var calendar = $("body #calendar").flatpickr({
                  altInput: true,
                  altFormat: "F j, Y",
                  dateFormat: "Y-m-d",
                  minDate: new Date().fp_incr(1),
                  maxDate: new Date().fp_incr(365), // 90 days from now
                  disable: [
                      "2025-11-27", // Thanks Giving
                      "2025-12-25", // Christmas Day
                      "2026-01-01" // New Year's Day
                  ]
                  /* disable: [
                      function(date) {
                          return (date.getDay() === 0 || date.getDay() === 6);
                      },
                      "2025-09-01", // Labor Day
                      "2025-10-13", // Columbus Day,
                      "2025-11-11", // Veterans Day,
                      "2025-11-27", // Thanks Giving
                      "2025-12-25", // Christmas Day
                      "2026-01-01", // New Year's Day
                      "2026-01-19", // Martin Luther King Day
                      "2026-02-16", // Presidents' Day/Washington's Birthday
                      "2026-07-04", // Independence Day
                      "2026-06-19", // Juneteenth (June 19th)
                      "2026-07-03", // Independence Day (Observed - Friday, since July 4th falls on Saturday)
                      "2026-09-07", // Labor Day (First Monday in September)
                      "2026-10-12", // Columbus Day (Second Monday in October)
                      "2026-11-11", // Veterans Day (November 11th)
                      "2026-11-26", // Thanksgiving Day (Fourth Thursday in November)
                      "2026-12-25", // Christmas Day (December 25th)
                      "2027-01-01" // New Year's Day
                  ] */
              });

              document.getElementById('calBtn').onclick = function(e){
                  calendar.open();
              };
            }

            if(data.flatpickr) {
              $(".flatpickr").flatpickr();
            }

            if(data.scroll) {
              $('html,body').animate({scrollTop: $(data.scroll_to).offset().top - (data.scroll_offset || 150)}, 'slow');
            }

            // Refresh modal window according to an interval in milliseconds.
            if (typeof data.monitor !== 'undefined') {
              if(data.monitor.reload) {
                setTimeout(function() {
                  turbo($(data.monitor.element));
                }, data.monitor.interval || 5000);
              }
            }
          })
          .fail(function (jqXHR) {
            // Display an alert for the user containing the returned message error.
            alert(JSON.parse(jqXHR.responseText).message);
          })
          .always(function() {
            $(".btn-turbo").attr("disabled", false);
            if (! e.data('no-modal')) {
              $(modalWindow + ' .modal-dialog-loader').hide();
              $(modalWindow + ' .modal-dialog-live').show();
            }
            if (show) {
              $(show).hide();
            }
            if (hide) {
              $(hide).show();
            }
          });
  }
});
